.root {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-2xs);
    cursor: pointer;
    font-size: var(--mantine-font-size-sm);
    color: var(--dib-ink);
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
    transition:
        padding-left 0.15s ease,
        background-color 0.15s ease;

    &:focus-visible {
        outline: none;
        box-shadow: inset 0 0 0 2px var(--dib-text-dark-blue-rgb);
    }

    &:hover {
        padding-left: calc(var(--mantine-spacing-xs) + 5px);
    }

    &[data-active] {
        padding-left: calc(var(--mantine-spacing-xs) + 5px);
        color: var(--dib-text-dark-blue-rgb);
        background-color: var(--dib-surface);
    }
}


.draggable {
    padding-top: var(--mantine-spacing-xs);
    padding-bottom: var(--mantine-spacing-xs);
}

.dragHandle {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 0;
    overflow: hidden;
    opacity: 0;
    cursor: grab;
    transition:
        width 0.15s ease,
        opacity 0.15s ease;

    & > svg {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
    }
}

.root:hover .dragHandle {
    width: 14px;
    opacity: 1;
}

.icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    display: flex;
    align-items: center;

    & > svg {
        width: 18px;
        height: 18px;
    }
}

.chevron {
    margin-left: auto;
    display: flex;
    align-items: center;
    color: var(--mantine-color-gray-5);
    transition: color 0.15s ease;

    & > svg {
        width: 20px;
        height: 20px;
        transform: translateY(2px);
    }
}

.root:hover .chevron {
    color: var(--dib-ink);
}

.root[data-active] .chevron {
    color: var(--dib-text-dark-blue-rgb);
}
